import { render, staticRenderFns } from "./TsCoursePanel.vue?vue&type=template&id=e2c105be"
import script from "./TsCoursePanel.vue?vue&type=script&lang=ts"
export * from "./TsCoursePanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports